import Vue from 'vue';
import filterPresetService from "@/components/base_components/tables/services/filter-preset-service";
import i18n from '../../../../../language/i18n'

const showError = (dispatch, errorMessage) => {
    dispatch('errorNotificationStore/setErrors', errorMessage);
    dispatch('errorNotificationStore/showErrorNotification');
}

export default {
    namespaced: true,
    state: {
        presets: {}
    },
    mutations: {
        setNewPresets(state, { concept, presets}) {
            Vue.set(state.presets, concept, presets);
        },
        resetStore(state) {
            Vue.set(state, 'presets', {});
        }
    },
    actions: {
        async loadAndSetPresetsFor({ commit, dispatch }, concept) {
            try {
                const response = await filterPresetService.getAllFilterPresetsByConcept(concept);
                commit('setNewPresets', { concept, presets: response.data.data });
            } catch (e) {
                const errorMessage = i18n.t('Components.sentences.errorLoadingPreset');
                showError(dispatch, errorMessage);
            }
        },
        resetStore({ commit }) {
            commit('resetStore');
        }
    },
    getters: {
        getPresetsFor: (state) => (concept) => {
            return state.presets[concept];
        },
        arePresetsLoadedFor: (state) => (concept) => {
            return state.presets?.[concept] !== undefined;
        }
    }
}
